import { Navigate } from 'react-router-dom';
import { lazy } from 'react';
import { Result } from 'antd';

// 一级路由
const routes = [
  {
    path: '/',
    component: () => <Navigate to="/home" />,
  }, {
    path: '/',
    component: lazy(() => import('@/pages/Layout')),
    children: [
      {
        path: '/home',
        name: 'homeChildren',
        component: lazy(() => import('@/pages/Home')),
      },
      {
        path: '/productCenter',
        name: 'productCenter',
        component: lazy(() => import('@/pages/ProductCenter')),
      },
      {
        path: '/projectLibrary',
        name: 'projectLibrary',
        component: lazy(() => import('@/pages/ProjectLibrary')),
      },
      {
        path: '/newsDynamics',
        name: 'newsDynamics',
        component: lazy(() => import('@/pages/NewsDynamics')),
      },
      {
        path: '/about',
        name: 'about',
        component: lazy(() => import('@/pages/About')),
      },
    ],
  }, {
    path: '*',
    component: () => (
      <Result
        status="404"
        title="404"
        subTitle="对不起, 你访问的页面不存在！"
      />
    ),
  },
];

export default routes;
